// Global Instructions Rule Applied!

import {
  FilterValue,
  SortConfig,
  SetFilterOptionsAction,
  SetCompaniesAction,
  SetActiveFiltersAction,
  SetActiveSortingAction,
  ClearActiveFiltersAction,
  UpdateCompanyRecordAction,
  AddCompanyAction,
  AppendCompaniesAction,
  UpdateCompanyRoundAction,
  RemoveCompanyFromListAction
} from '../../interfaces/companies.ts'
import { CompaniesPaginatedResponse } from '../../../app_modules/companies/services/companiesService.ts'
import { TableFilterOptionsResponse } from '../../rpc_models/get_table_filter_options_response.ts'
import { AccountRecord } from '../../data_models/account_record.ts'
import {
  SET_FILTER_OPTIONS,
  SET_COMPANIES,
  SET_ACTIVE_FILTERS,
  SET_ACTIVE_SORTING,
  CLEAR_ACTIVE_FILTERS,
  UPDATE_COMPANY_RECORD,
  ADD_COMPANY,
  APPEND_COMPANIES,
  UPDATE_COMPANY_ROUND,
  REMOVE_COMPANY_FROM_LIST
} from './constants.ts'

export const setFilterOptions = ({ response }: { response: TableFilterOptionsResponse }): SetFilterOptionsAction => ({
  type: SET_FILTER_OPTIONS,
  payload: { response }
})

export const setCompanies = ({ response }: { response: CompaniesPaginatedResponse }): SetCompaniesAction => ({
  type: SET_COMPANIES,
  payload: { response }
})

export const setActiveFilters = ({ filters }: { filters: FilterValue[] }): SetActiveFiltersAction => ({
  type: SET_ACTIVE_FILTERS,
  payload: { filters }
})

export const setActiveSorting = ({ sorting }: { sorting: SortConfig[] }): SetActiveSortingAction => ({
  type: SET_ACTIVE_SORTING,
  payload: { sorting }
})

export const clearActiveFilters = (): ClearActiveFiltersAction => ({
  type: CLEAR_ACTIVE_FILTERS,
  payload: {}
})

export const updateCompanyRecord = ({
  companyId,
  updates
}: {
  companyId: string
  updates: Record<string, any>
}): UpdateCompanyRecordAction => ({
  type: UPDATE_COMPANY_RECORD,
  payload: { companyId, updates }
})

export const addCompany = ({ company }: { company: AccountRecord }): AddCompanyAction => ({
  type: ADD_COMPANY,
  payload: { company }
})

export const appendCompanies = ({ response }: { response: CompaniesPaginatedResponse }): AppendCompaniesAction => ({
  type: APPEND_COMPANIES,
  payload: { response }
})

export const updateCompanyRound = ({
  roundId,
  updates
}: {
  roundId: string
  updates: Record<string, any>
}): UpdateCompanyRoundAction => ({
  type: UPDATE_COMPANY_ROUND,
  payload: { roundId, updates }
})

export const removeCompanyFromList = ({
  companyId
}: {
  companyId: string
}): RemoveCompanyFromListAction => ({
  type: REMOVE_COMPANY_FROM_LIST,
  payload: { companyId }
})
